import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { formAPIParamPath } from '../../../../../utils/StringUtils';
import { UpdateAccessArrangementData } from '../../model';

export const GET_ACCESS_ARRANGEMENT_REQUEST = '';
export const DELETE_ACCESS_ARRANGEMENT_REQUEST = (uuid: string) => `${uuid}`;
export const GET_ACCESS_ARRANGEMENT_GET_DRAFT_APPLICATION = 'pending-request';
export const POST_ACCESS_ARRANGEMENT_POST_DRAFT_APPLICATION = 'pending-request';
export const POST_ACCESS_ARRANGEMENT_POST_DRAFT_APPLICATION1 = (uuid: string) =>
  `pending-request/${uuid}`;

export const POST_ACCESS_ARRANGEMENT_NEW_DRAFT_APPLICATION = '';
export const POST_ACCESS_ARRANGEMENT_COORDINATOR_NEW_DRAFT_APPLICATION = (uuid: string) =>
  `${uuid}`;

export const GET_ACCESS_ARRANGEMENT_MEDICAL_CONDITIONS = 'medical-conditions';
export const GET_ACCESS_ARRANGEMENT_SELECTED_CONDITIONS = (uuid: string) =>
  `${uuid}/medical-conditions-and-attached-files`;
export const GET_ACCESS_ARRANGEMENT_DRAFT_DATE_TIME = (uuid: string) => `${uuid}/draft-datetime`;
export const POST_ACCESS_ARRANGEMENT_MODIFY_SELECTED_MEDICAL_CONDITIONS = (uuid: string) =>
  `${uuid}/medical-conditions`;
export const DELETE_ACCESS_ARRANGEMENT_FILE = (uuid: string) => `attached-files/${uuid}`;
export const GET_ACCESS_ARRANGEMENT_REQUEST_DETAILS = (uuid: string, params: ApiPathParam) => {
  const tparams = formAPIParamPath(params);
  return `${uuid}/request-details${tparams}`;
};
export const POST_ACCESS_ARRANGEMENT_REQUEST_DETAILS = (uuid: string) => `${uuid}/request-details`;
export const PUT_ACCESS_ARRANGEMENT_REQUEST_DETAILS = (uuid: string) => `${uuid}/request-details`;
export const DELETE_ACCESS_ARRANGEMENT_REQUEST_DETAILS = (uuid: string, detailUuid: string) =>
  `${uuid}/request-details/${detailUuid}`;
export const POST_ACCESS_ARRANGEMENT_UPLOAD_DOCUMENTS = (uuid: string) => `${uuid}/attached-files`;
export const GET_ACCESS_ARRANGEMENT_REVIEW_DETAILS = (uuid: string) =>
  `${uuid}/candidate-profile-and-access-arrangement`;
export const PUT_ACCESS_ARRANGEMENT_UPDATE_DRAFT = ({
  uuid,
  clear = false,
}: UpdateAccessArrangementData) => `${uuid}?clear=${clear}`;
export const GET_ACCESS_ARRANGEMENT_REQUEST_ACKNOWLEDGEMENT = (uuid: string) =>
  `${uuid}/request-acknowledgement`;
export const GET_ACCESS_ARRANGEMENT_SUMMARY = (uuid: string) => `${uuid}`;
export const GET_ACCESS_ARRANGEMENT_PDF = (uuid: string) => `${uuid}/download-request`;
export const GET_ACCESS_ARRANGEMENT_UPLOAD_DOCUMENTS_STATUS = (uuid: string) =>
  `attached-files/files-status/${uuid}`;
export const GET_MEDICAL_CONDITIONS_AMENDMENT = (uuid: string) =>
  `${uuid}/medical-conditions-and-attached-files/amendment`;
export const GET_ACCESS_ARRANGEMENT_MEDICAL_CONDITIONS_AMENDMENT = (uuid: string) =>
  `${uuid}/medical-conditions`;
export const GET_ACCESS_ARRANGEMENT_REVIEW_DETAILS_AMENDMENT = (uuid: string) =>
  `${uuid}/candidate-profile-and-access-arrangement/amendment`;

export const GET_ACCESS_ARRANGEMENT_INDIVIDUAL_REPORT_FILES = (uuid: string) =>
  `${uuid}/individual-report-files`;

export const GET_ACCESS_ARRANGEMENT_INDIVIDUAL_REPORT_TEMPLATE =
  `individual-report-template`;

export const GET_ACCESS_ARRANGEMENT_INDIVIDUAL_REPORT_SUBMITTED_FILES = (uuid: string) =>
  `${uuid}/individual-report-files/submitted`;

